var frenchDOMTOMList = [
    { zip: 971, code: 'GP', name: window.i18n.__('Guadeloupe') },
    { zip: 972, code: 'MQ', name: window.i18n.__('Martinique') },
    { zip: 973, code: 'GF', name: window.i18n.__('Guyane française') },
    { zip: 974, code: 'RE', name: window.i18n.__('Réunion') },
    { zip: 975, code: 'PM', name: window.i18n.__('Saint-Pierre-Et-Miquelon') },
    { zip: 976, code: 'YT', name: window.i18n.__('Mayotte') },
    { zip: 984, code: 'TF', name: window.i18n.__('Terres australes françaises') },
    { zip: 987, code: 'PF', name: window.i18n.__('Polynésie française') },
    { zip: 986, code: 'WF', name: window.i18n.__('Wallis et futuna') },
    { zip: 988, code: 'NC', name: window.i18n.__('Nouvelle-Calédonie') },
];

export { frenchDOMTOMList };